export enum FORM_SESSION_STATUS {
  PENDING = 'PENDING',
  SUBMITTED = 'SUBMITTED',
}

export enum FORM_SESSION_VALIDATION_STATUS {
  FORM_ALREADY_AVAILABLE = 'FORM_ALREADY_AVAILABLE',
  SUCCESS = 'SUCCESS',
}